<form [formGroup]="NoteFormGroup">
  <div class="modal-header">
    <h3 class="mb-0">Add note</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label class="form-label" requiredAsterisk>Title</label>
      <select class="form-select" formControlName="title">
        @for (title of getNoteTitles(); track title) {
          <option [ngValue]="title">
            {{ title }}
          </option>
        }
      </select>
    </div>

    <div class="form-group">
      <label class="form-label" requiredAsterisk>Note</label>
      <textarea class="form-control" formControlName="note" rows="6"></textarea>
    </div>

    <div class="check-group mt-0">
      <input
        type="checkbox"
        class="form-check-input"
        formControlName="isSensitive"
        id="compliance-internal"
      />
      <label class="form-check-label mt-0" for="compliance-internal">
        Internal note?
      </label>
    </div>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-ghost" (click)="close()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" (click)="saveNote()">
        Save
      </button>
    </div>
  </div>
</form>
